import { Component, Input } from '@angular/core';

@Component ({
    selector: 'cmn-card',
    templateUrl: './card.component.html',
    styleUrls: [ './card.component.scss' ],
})

export class CardComponent {
    @Input() public readonly text: string;
    @Input() public readonly title: string;
    @Input() public readonly image: string;
    @Input() public readonly hasBorder: boolean;
}
